import React, {
  useEffect,
  useState,
  useImperativeHandle,
  forwardRef,
} from "react";
import { Button, message, Pagination, Popover, Table, Tag } from "antd";
import { Splitter } from "antd";
import {
  CloseOutlined,
  CheckOutlined,
  InfoCircleOutlined,
  FormOutlined,
} from "@ant-design/icons";
import CommonTopDetails from "../../CommonTopDetails";
import useCommonListing from "../../customHooks/useCommonListing";
import {
  capitalizeWords,
  ModuleColor,
  ModuleTagName,
} from "../../../icons/ApplicationColor";
import { GetFormattedDateTime } from "../../../utils/DateTimeUtils";
import axiosInstance from "../../../../api/Axios";

const ClientsAssign = forwardRef(
  (
    {
      open,
      onClose,
      userInfo,
      initialSelectedRowKeys,
      initialCurrentPage,
      initialPageSize,
      initialUrl,
      fullscreen,
      setFullscreen,
      loadAgain,
    },
    ref
  ) => {
    const [selectedRowKeys1, setSelectedRowKeys1] = useState(
      initialSelectedRowKeys || []
    );
    const [selectedRowKeys2, setSelectedRowKeys2] = useState([]);
    const columns = [
      {
        title: "Course ID",
        dataIndex: "course_id",
        key: "course_id",
        width: 100,
      },
      {
        title: "Course Title",
        dataIndex: "name",
        key: "name",
        ellipsis: !fullscreen,
        width: 295,
      },
      { title: "Course Mode", dataIndex: "mode", key: "mode", width: 110 },
      ...(fullscreen
        ? [
            {
              title: "Category",
              dataIndex: "category",
              key: "category",
              width: 160,
            },
            {
              title: "Language",
              dataIndex: "language",
              key: "language",
              width: 120,
            },
            {
              title: "Created At",
              dataIndex: "created_at",
              key: "created_at",
              width: 120,
              render: GetFormattedDateTime,
            },
          ]
        : []),
    ];
    const columns2 = [
      {
        title: capitalizeWords("CLIENT ID"),
        dataIndex: "client_id",
        key: "client_id",
        width: 100,
      },
      {
        title: capitalizeWords("CLIENT NAME"),
        dataIndex: "name",
        key: "name",
        ellipsis: !fullscreen,
        width: 245,
      },
      {
        title: capitalizeWords("USERS"),
        dataIndex: "user_count",
        key: "user_count",
        width: 110,
        align: "center",
      },

      ...(fullscreen
        ? [
            {
              title: capitalizeWords("PRODUCTS"),
              dataIndex: "applications",
              key: "applications",
              width: 150,
              render: (applications) => (
                <span>
                  {applications.map((tag, index) => {
                    return (
                      <Tag
                        color={ModuleColor(tag.name)}
                        key={index}
                        title={tag.name}
                        style={{ margin: "3px" }}
                      >
                        <span style={{ color: "black", fontWeight: "500" }}>
                          {ModuleTagName(tag.name)}
                        </span>
                      </Tag>
                    );
                  })}
                </span>
              ),
            },
            {
              title: capitalizeWords("CONTRACT START"),
              dataIndex: "contract_start_date",
              key: "contract_start_date",
              width: 172,

              render: GetFormattedDateTime,
            },
            {
              title: capitalizeWords("CONTRACT END"),
              dataIndex: "contract_end_date",
              key: "contract_end_date",
              width: 155,
              render: GetFormattedDateTime,
            },
          ]
        : []),
    ];
    const [buttonLoading, setButtonLoading] = useState(false);
    const [combinedApiData, setCombinedApiData] = useState([]);
    const [apiLoading, setApiLoading] = useState(false);
    const {
      data,
      itemsLength,
      loading,
      filterData,
      onShowSizeChange,
      onPageChange,
      handleSearchChange,
      setFilterData,
      // handleSwitchChange,
      // handleClearAll,
      // setFilterUrl,
    } = useCommonListing({
      userInfo,
      passSize: initialSelectedRowKeys?.length > 0 ? initialPageSize : 10,
      passPage: initialSelectedRowKeys?.length > 0 ? initialCurrentPage : 1,
      passURL: `/courselist/?organization=${userInfo?.data?.organization?.id}`,
      modalOpen: open,
    });
    useEffect(() => {
      setSelectedRowKeys1(initialSelectedRowKeys || []);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);
    useEffect(() => {
      if (open && initialSelectedRowKeys?.length > 0) {
        console.log(initialSelectedRowKeys);
        setSelectedRowKeys1(initialSelectedRowKeys || []);
        setFilterData((prevData) => ({
          ...prevData,
          currentPage: initialCurrentPage || 1,
          pageSize: initialPageSize || 10,
          filter_url: initialUrl || "",
        }));
      } else {
        console.log(initialSelectedRowKeys);
      }
    }, [
      initialSelectedRowKeys,
      setFilterData,
      initialCurrentPage,
      initialPageSize,
      initialUrl,
      open,
    ]);
    // eslint-disable-next-line no-unused-vars
    const { pageSize, currentPage, active, filter_url } = filterData;
    const {
      data: data2,
      itemsLength: itemsLength2,
      loading: loading2,
      filterData: filterData2,
      onShowSizeChange: onShowSizeChange2,
      onPageChange: onPageChange2,
      handleSearchChange: handleSearchChange2,
      // setFilterData: setFilterData2,
      // handleSwitchChange: handleSwitchChange2,
      // handleClearAll: handleClearAll2,
      // setFilterUrl: setFilterUrl2,
    } = useCommonListing({
      userInfo,
      passSize: 10,
      passPage: 1,
      passURL: `/organizationlist/`,
    });

    const {
      pageSize: pageSize2,
      currentPage: currentPage2,
      // active: active2,
      // filter_url: filter_url2,
    } = filterData2;

    const rowSelection1 = {
      selectedRowKeys: selectedRowKeys1,
      onChange: (newSelectedKeys, selectedRows) => {
        // Get all keys visible on current page
        const currentPageKeys = data.map((row) => row.id);

        // Create a Set from current selections
        const updatedKeysSet = new Set(selectedRowKeys1);

        // Remove any deselected keys from current page
        currentPageKeys.forEach((key) => {
          updatedKeysSet.delete(key);
        });

        // Add all newly selected keys
        newSelectedKeys.forEach((key) => {
          updatedKeysSet.add(key);
        });

        // Final merged keys
        const finalKeys = Array.from(updatedKeysSet);
        setSelectedRowKeys1(finalKeys);
      },
    };
    function getCookie(name) {
      const cookies = document.cookie.split("; ");
      for (let i = 0; i < cookies.length; i++) {
        const [cookieName, cookieValue] = cookies[i].split("=");
        if (cookieName === name) {
          return cookieValue;
        }
      }
      return null;
    }
    const csrfToken = getCookie("csrftoken");

    const fetchCombinedData = async (courseIds, organizationIds) => {
      setApiLoading(true);
      try {
        const response = await axiosInstance.post(
          "/courseorganizationlookup/",
          {
            course_ids: courseIds,
            organization_ids: organizationIds,
          },
          {
            headers: {
              "X-CSRFToken": csrfToken,
            },
          }
        );
        setCombinedApiData(response?.data?.data || []);
      } catch (error) {
        setCombinedApiData(null);
        // Optionally handle error
        console.error("Combined API error:", error);
      } finally {
        setApiLoading(false);
      }
    };

    useEffect(() => {
      if (selectedRowKeys1.length > 0 && selectedRowKeys2.length > 0) {
        fetchCombinedData(selectedRowKeys1, selectedRowKeys2);
      } else {
        setCombinedApiData(null);
      }
      // eslint-disable-next-line
    }, [selectedRowKeys1, selectedRowKeys2]);

    const rowSelection2 = {
      selectedRowKeys: selectedRowKeys2,
      onChange: (newSelectedKeys, newSelectedRows) => {
        // Get all keys visible on current page
        const currentPageKeys = data2.map((row) => row.id || row.client_id);

        // Create a Set from current selections
        const updatedKeysSet = new Set(selectedRowKeys2);

        // Remove any deselected keys from current page
        currentPageKeys.forEach((key) => {
          updatedKeysSet.delete(key);
        });

        // Add all newly selected keys
        newSelectedKeys.forEach((key) => {
          updatedKeysSet.add(key);
        });

        // Final merged keys
        const finalKeys = Array.from(updatedKeysSet);
        setSelectedRowKeys2(finalKeys);
      },
    };
    const [selectedCombinedRowKeys, setSelectedCombinedRowKeys] = useState([]);

    // When combinedApiData changes, auto-select unassigned rows
    useEffect(() => {
      if (combinedApiData && combinedApiData.length > 0) {
        const autoSelected = combinedApiData
          .filter((row) => row.assigned_status === false)
          .map((row) => `${row.course_id}_${row.organization_id}`);
        setSelectedCombinedRowKeys(autoSelected);
      } else {
        setSelectedCombinedRowKeys([]);
      }
    }, [combinedApiData]);
    const renderStatus = (text, record) => {
      if (!text) {
        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div
              style={{
                width: "1.8rem",
                height: "1.8rem",
                borderRadius: "50%",
                backgroundColor: "#52c41a",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CheckOutlined
                style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
              />
            </div>
          </div>
        );
      } else {
        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Popover
              title="Already Assigned"
              content={
                <div>
                  <div>
                    <InfoCircleOutlined
                      style={{ color: "#1890ff", marginRight: 4 }}
                    />
                    <span style={{ color: "gray" }}>Message :</span>{" "}
                    {record.Message}
                  </div>
                  <div>
                    <span style={{ color: "gray" }}>Assigned At:</span>{" "}
                    {record.assigned_at
                      ? GetFormattedDateTime(record.assigned_at, true)
                      : "-"}
                  </div>
                </div>
              }
            >
              <div
                style={{
                  width: "1.8rem",
                  height: "1.8rem",
                  borderRadius: "50%",
                  backgroundColor: "#ff4d4f",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CloseOutlined
                  style={{ color: "#fff", fontSize: "1rem", fontWeight: "600" }}
                />
              </div>
            </Popover>
          </div>
        );
      }
      // else {
      //   return text;
      // }
    };

    const mergedCourses = {};

    combinedApiData?.forEach((item) => {
      const key = item.course_name;
      if (!mergedCourses[key]) {
        mergedCourses[key] = 0;
      }
      mergedCourses[key]++;
    });

    const combinedColumns = [
      {
        title: "Course Name",
        dataIndex: "course_name",
        key: "course_name",
        render: (text, row, index) => {
          const courseName = row.course_name;
          const firstOccurrence = combinedApiData.findIndex(
            (item) => item.course_name === courseName
          );

          if (index === firstOccurrence) {
            return {
              children: text,
              props: {
                rowSpan: mergedCourses[courseName],
              },
            };
          } else {
            return {
              children: null,
              props: {
                rowSpan: 0,
              },
            };
          }
        },
      },
      {
        title: "Organization Name",
        dataIndex: "organization_name",
        key: "organization_name",
      },
      {
        title: "Assignment Eligibility",
        dataIndex: "assigned_status",
        key: "assigned_status",
        render: renderStatus,
        width: 200,
        align: "center",
      },
    ];

    const combinedRowSelection = {
      selectedRowKeys: selectedCombinedRowKeys,
      onChange: setSelectedCombinedRowKeys,
      getCheckboxProps: (record, idx) => ({
        disabled: record.assigned_status === true,
      }),
    };

    useImperativeHandle(ref, () => ({
      handleCloseChild,
    }));

    const handleCloseChild = () => {
      setFullscreen(false);
      setSelectedRowKeys1([]);
      setSelectedRowKeys2([]);
      setCombinedApiData([]);
      setSelectedCombinedRowKeys([]);
      setApiLoading(false);
      onClose();
    };
    const combinedApiDataWithKeys = (combinedApiData || []).map((row) => ({
      ...row,
      key: `${row.course_id}_${row.organization_id}`,
    }));
    const submitData = async () => {
      setButtonLoading(true);
      const selectedRows = combinedApiDataWithKeys.filter((row) =>
        selectedCombinedRowKeys.includes(row.key)
      );

      // Prepare your payload as needed
      const courseIds = [...new Set(selectedRows.map((row) => row.course_id))];
      const organizationIds = [
        ...new Set(selectedRows.map((row) => row.organization_id)),
      ];
      try {
        await axiosInstance.post(
          "/courseorganizationbulkassign/",
          {
            course_ids: courseIds,
            organization_ids: organizationIds,
            type: "organization_assign",
          },
          {
            headers: {
              "X-CSRFToken": csrfToken,
            },
          }
        );
        message.success("Bulk assignment successful!");
      } catch (error) {
        message.error("Bulk assignment failed. Please try again.");
      } finally {
        setButtonLoading(false);
        loadAgain();
        handleCloseChild();
      }
    };
    return (
      <div
        style={{
          width: "100%",
          overflow: "hidden",
        }}
      >
        <Splitter style={{ width: "100%" }}>
          <Splitter.Panel
            defaultSize="50%"
            min="20%"
            max="80%"
            className="table-wrapper"
            style={{ overflowX: "auto", overflowY: "hidden" }}
          >
            <CommonTopDetails
              title={active ? "Courses" : "Inactive Courses"}
              titleSuffix={`${itemsLength || 0} course(s)`}
              searchPlaceholder="Search by ID or Title"
              searchAction={handleSearchChange}
              marginPass="15px"
              paddingInlinepass="10px"
              showAddButton={false}
              filterAction={false}
              filterUrl={false}
            />
            <Table
              columns={columns}
              dataSource={data}
              size="small"
              bordered
              rowKey="id"
              className="table-container"
              scroll={{
                x: 200,
                y: fullscreen ? 500 : 400,
              }}
              loading={loading}
              style={{ marginInline: "1rem" }}
              pagination={false}
              rowSelection={rowSelection1}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "1rem",
              }}
            >
              <Pagination
                size="small"
                showSizeChanger
                onShowSizeChange={onShowSizeChange}
                onChange={onPageChange}
                pageSizeOptions={["5", "10", "15", "30", "50", "100"]}
                current={currentPage}
                defaultPageSize={pageSize}
                total={itemsLength}
              />
            </div>
          </Splitter.Panel>
          <Splitter.Panel
            defaultSize="50%"
            min="20%"
            max="80%"
            className="table-wrapper"
            style={{ overflowX: "auto", overflowY: "hidden" }}
          >
            <CommonTopDetails
              title={active ? "Clients" : "Inactive Courses"}
              titleSuffix={`${itemsLength2 || 0} client(s)`}
              searchPlaceholder="Search by ID or Title"
              searchAction={handleSearchChange2}
              marginPass="15px"
              paddingInlinepass="10px"
              showAddButton={false}
              filterAction={false}
              filterUrl={false}
            />
            <Table
              columns={columns2}
              dataSource={data2}
              size="small"
              bordered
              rowKey="id"
              className="table-container"
              scroll={{
                x: 200,
                y: fullscreen ? 500 : 400,
              }}
              style={{ marginInline: "1rem" }}
              pagination={false}
              loading={loading2}
              rowSelection={rowSelection2}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "1rem",
              }}
            >
              <Pagination
                size="small"
                showSizeChanger
                onShowSizeChange={onShowSizeChange2}
                onChange={onPageChange2}
                pageSizeOptions={["5", "10", "15", "30", "50", "100"]}
                current={currentPage2}
                defaultPageSize={pageSize2}
                total={itemsLength2}
              />
            </div>
          </Splitter.Panel>
        </Splitter>
        {combinedApiData?.length > 0 && (
          <div style={{ marginTop: 22 }}>
            <h5 style={{ fontWeight: 500, fontSize: 16, marginBottom: 16 }}>
              <span
                role="img"
                aria-label="link"
                style={{ marginRight: 8, color: "#1890ff" }}
              >
                🔗
              </span>
              Combined Selection
            </h5>
            <Table
              columns={combinedColumns}
              scroll={{
                x: 200,
                y: fullscreen ? "calc(100vh - 160px)" : 430,
              }}
              dataSource={combinedApiDataWithKeys}
              className="table-container"
              size="small"
              bordered
              rowSelection={combinedRowSelection}
              pagination={false}
              rowKey="key"
              loading={apiLoading}
              style={{
                marginInline: "1rem",
              }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                margin: "3rem",
                marginInline: "2rem",
                marginBottom: "1rem",
              }}
            >
              <Button
                key="back"
                onClick={(e) => {
                  e.stopPropagation();
                  handleCloseChild();
                }}
                style={{ marginRight: "1rem" }}
              >
                <CloseOutlined />
                Cancel
              </Button>

              <Button
                type="primary"
                htmlType="submit"
                onClick={submitData}
                loading={buttonLoading}
                disabled={selectedCombinedRowKeys.length === 0}
              >
                Save Assignment{combinedApiData.length > 1 ? "s" : ""}
                <FormOutlined />
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }
);

export default ClientsAssign;
